var adapters = {};
var trackEvent = function trackEvent() {};
var callbacks = {};
var hooks = {};
var coreUrl = '';
var getAdapter = function getAdapter(name) {
  return adapters[name];
};
var getCoreUrl = function getCoreUrl() {
  return coreUrl;
};
var setAdapters = function setAdapters(newAdapters) {
  return adapters = newAdapters;
};
var setCallbacks = function setCallbacks(newCallbacks) {
  return callbacks = newCallbacks;
};
var setTrackEvent = function setTrackEvent(newTrackEvent) {
  return trackEvent = newTrackEvent;
};
var setHooks = function setHooks(newHooks) {
  return hooks = newHooks;
};
var setCoreUrl = function setCoreUrl(newCoreUrl) {
  return coreUrl = newCoreUrl;
};
export { getAdapter, getCoreUrl, setAdapters, setCallbacks, setTrackEvent, setHooks, setCoreUrl, callbacks, trackEvent, hooks, coreUrl };
//# sourceMappingURL=api.js.map